// Wait for the page-level initialization callback so components are registered
// only after i18n and other shared application state are ready.
const whenTCInitialized = () => {
  if (window.TC?.initialized) return Promise.resolve()

  return new Promise((resolve) => {
    document.addEventListener("tc:initialized", resolve, { once: true })
  })
}

export default whenTCInitialized
